<div class="profile-settings">

    <div class="profile-settings-title-wrap">

        <div class="profile-settings-title rpc-title-font">
            {{ 'PROFILE.TITLES.NOTIFICATIONS' | translate }}
        </div>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-section">

        <div class="profile-settings-section-title rpc-title-font">
            {{ 'PROFILE.TITLES.PORTFOLIO' | translate }}
        </div>

        <email-alert-settings class="profile-settings-section-block" [isSelfProfile]="isSelfProfile"
            [settingsFor]="'listing'" [settings]="settings" [isSmsAvailable]="isSmsAvailable"
            [hasSmsAlertsNumber]="hasSmsAlertsNumber" (settingsChanged)="onSettingsChanged($event)">
        </email-alert-settings>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-section">

        <div class="profile-settings-section-title rpc-title-font">
            {{ 'PROFILE.TITLES.APPOINTMENTS' | translate }}
        </div>

        <email-alert-settings class="profile-settings-section-block" [isSelfProfile]="isSelfProfile"
            [settings]="settings" [settingsFor]="'appointment'" [isSmsAvailable]="isSmsAvailable"
            [hasSmsAlertsNumber]="hasSmsAlertsNumber" (settingsChanged)="onSettingsChanged($event)">
        </email-alert-settings>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-section">

        <div class="profile-settings-section-title rpc-title-font">
            {{ 'PROFILE.TITLES.SAVED_SEARCHES' | translate }}
        </div>

        <new-match-settings class="profile-settings-section-block profile-settings-section-block--nm"
            [settings]="newMatchSettings" (settingsChanged)="onNewMatchSettingsChanged($event)">
        </new-match-settings>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-title-wrap profile-settings-title-wrap--system">

        <div class="profile-settings-title rpc-title-font">
            {{ 'PROFILE.TITLES.SYSTEM' | translate }}
        </div>

    </div>

    @if (isSelfProfile) {
    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-section">

        <div class="profile-settings-section-title rpc-title-font">
            {{ 'PROFILE.TITLES.DARK_MODE' | translate }}
        </div>

        <div class="profile-settings-section-block profile-settings-section-block--dark-mode">

            <rpc-slide-toggle class="theme-toggle" [checked]="settings?.layoutSettings?.darkMode"
                [firstText]="'PROFILE.TEXT.DARK_MODE_NOTE'" [togglePosition]="'left'"
                (changed)="onDarkModeSelected($event.checked)">
            </rpc-slide-toggle>

        </div>

    </div>
    }

    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-section">

        <div class="profile-settings-section-title rpc-title-font">
            {{ 'PROFILE.TITLES.CHANGE_PASSWORD' | translate }}
        </div>

        <div class="profile-settings-section-block profile-settings-section-block--change-password">

            <change-password class="profile-settings-section-box-inner" [isAdditionalProfile]="!isSelfProfile"
                (passwordChanged)="onPasswordChanged($event)">
            </change-password>

        </div>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-settings-divider">
    </div>

    <div class="profile-settings-section">

        <div class="profile-settings-section-title rpc-title-font">
            {{ 'PROFILE.TITLES.DEACTIVATE_ACCOUNT' | translate }}
        </div>

        <div class="profile-settings-section-block profile-settings-section-block--deactivate">

            <rpc-button class="deactivate" [color]="'warn'" [appearanceType]="'stroke'"
                [text]="'PROFILE.TITLES.DEACTIVATE_ACCOUNT'" (clicked)="onDeactivateAccount()">
            </rpc-button>

        </div>

    </div>

</div>